const Coupon = () =>
  import(
    /* webpackChunkName: "financial-discount" */ '@/pages/financial/discount/coupon/index.vue'
  )
const CreateCoupon = () =>
  import(
    /* webpackChunkName: "financial-discount" */ '@/pages/financial/discount/coupon/create.vue'
  )
const GenerateCoupon = () =>
  import(
    /* webpackChunkName: "financial-discount" */ '@/pages/financial/discount/coupon/generate.vue'
  )
const EditCoupon = () =>
  import(
    /* webpackChunkName: "financial-discount" */ '@/pages/financial/discount/coupon/edit.vue'
  )

export default {
  path: 'coupon',
  meta: {
    label: 'coupons',
    auth: 'coupon'
  },
  component: {
    name: 'Coupon',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialDiscountCoupon',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Coupon
    },
    {
      name: 'FinancialCreateDiscountCoupon',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCoupon
    },
    {
      name: 'FinancialGenerateDiscountCoupon',
      path: 'generate',
      meta: {
        label: 'genarateCoupons',
        auth: 'generate'
      },
      component: GenerateCoupon
    },
    {
      name: 'FinancialEditDiscountCoupon',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCoupon,
      props: true
    }
  ]
}
